export const ALLOWED_ICON_ORIGINS = new Set([
    'https://assets.exxactcorp.com',
    'https://images.exxactcorp.com',
]);
